import React, { useEffect, useState } from "react";
import Terms from "../components/Terms/Terms";
import * as apis from "../apis";

export default function TermsContainer() {
  const [data, setData] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apis.getTerms();
        setData(res?.data?.termOfService);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return <Terms data={data} />;
}
